import gql from 'graphql-tag';

export const GET_SHIPPER_ORDER = gql`
  query GetShipperOrder($pickTicketId: Int!) {
    shipperOrder(pickTicketId: $pickTicketId) {
      orderId
      orderNumber
      pickTicketId
      customerName
      shippingAddress {
        name
        company
        street1
        street2
        street3
        city
        state
        postalCode
        country
        phone
        email
        isResidential
      }
      shippingMethodName
      shippingCarrierCode
      shippingServiceCode
      salesRepId
      createdBy
      customerEmail
      lineItems {
        lineItemId
        styleCode
        description
        quantity
        vendorPartNumber
      }
    }
  }
`;

export const GET_PENDING_PICK_TICKETS = gql`
  query GetPendingPickTickets {
    pendingPickTickets {
      pickTicketId
      pickTicketNumber
      createdAt
      orderId
      orderNumber
      isShipped
      trackingNumber
      items {
        lineItemId
        styleCode
        description
        quantity
        vendorPartNumber
      }
    }
  }
`;

export const GET_PICK_TICKET_BY_BARCODE = gql`
  query GetPickTicketByBarcode($barcode: String!) {
    pickTicketByBarcode(barcode: $barcode) {
      pickTicketId
      pickTicketNumber
      orderId
      orderNumber
      isShipped
      trackingNumber
    }
  }
`;

export const GET_RECENT_SHIPPER_ACTIVITY = gql`
  query GetRecentShipperActivity($limit: Int!, $startDate: DateTime, $endDate: DateTime, $search: String) {
    recentShipperActivity(limit: $limit, startDate: $startDate, endDate: $endDate, search: $search) {
      activityType
      timestamp
      pickTicketId
      pickTicketNumber
      orderId
      orderNumber
      customerName
      shippingLabelId
      labelId
      shipmentId
      shipStationSalesOrderId
      carrierCode
      carrierFriendlyName
      serviceCode
      serviceName
      trackingNumber
      trackingUrl
      labelData
      shippingCost
      isTestLabel
      isVoided
      isReturnLabel
      hasReturnLabel
      returnLabelId
      returnLabelTrackingNumber
      returnLabelData
      itemCount
      packageSequence
      totalPackages
      isMultiPackage
    }
  }
`;

// ==================== End of Day Queries ====================

export const GET_DAILY_SHIPPING_SUMMARY = gql`
  query GetDailyShippingSummary($reportDate: DateTime!) {
    dailyShippingSummary(reportDate: $reportDate) {
      reportDate
      labelsCreated
      labelsVoided
      returnLabelsCreated
      pickTicketsShipped
      totalShippingCost
      pendingManifestCount
      carrierBreakdown {
        carrierCode
        carrierName
        shipmentCount
        totalCost
        manifestStatus
        manifestId
        manifestDownloadUrl
        unmanifestedLabelCount
        supportsApiManifest
        manifestInstructions
      }
      manifests {
        manifestId
        carrierCode
        carrierName
        createdAt
        shipmentCount
        manifestDownloadUrl
      }
    }
  }
`;

export const GET_DAILY_SHIPMENTS = gql`
  query GetDailyShipments($reportDate: DateTime!, $carrierCode: String, $search: String, $page: Int!, $pageSize: Int!) {
    dailyShipments(reportDate: $reportDate, carrierCode: $carrierCode, search: $search, page: $page, pageSize: $pageSize) {
      shipments {
        shippingLabelId
        labelId
        createdAt
        pickTicketId
        orderId
        orderNumber
        customerName
        carrierCode
        carrierName
        serviceCode
        serviceName
        trackingNumber
        trackingUrl
        shippingCost
        isVoided
        isReturnLabel
        isManifested
        shipmentId
        packageSequence
        totalPackages
        isMultiPackage
      }
      totalCount
      page
      pageSize
    }
  }
`;

export const GET_UNMANIFESTED_LABELS = gql`
  query GetUnmanifestedLabels($shipDate: DateTime!, $carrierId: String) {
    unmanifestedLabels(shipDate: $shipDate, carrierId: $carrierId) {
      shippingLabelId
      labelId
      orderId
      orderNumber
      customerName
      trackingNumber
      carrierCode
      serviceCode
      shippingCost
      createdAt
    }
  }
`;

export const CREATE_CARRIER_MANIFEST = gql`
  mutation CreateCarrierManifest($carrierId: String!, $shipDate: DateTime!, $labelIds: [String!]) {
    createCarrierManifest(carrierId: $carrierId, shipDate: $shipDate, labelIds: $labelIds) {
      success
      manifestId
      manifestDownloadUrl
      shipmentCount
      carrierCode
      errorMessage
    }
  }
`;

// ==================== UPS Package Summary ====================

export const GET_UPS_PACKAGE_SUMMARY = gql`
  query GetUpsPackageSummary($reportDate: DateTime!) {
    upsPackageSummary(reportDate: $reportDate) {
      reportDate
      accountNumber
      accountName
      shipperName
      shipperStreet
      shipperCity
      shipperState
      shipperPostalCode
      totalPackages
      totalShipments
      totalCost
      serviceBreakdown {
        serviceCode
        serviceName
        upsCode
        packageCount
        shipmentCount
        totalCost
      }
      shipments {
        trackingNumber
        serviceCode
        upsCode
        orderNumber
        customerName
        shippingCost
        createdAt
        packageSequence
        totalPackages
        isMultiPackage
      }
      generatedAt
      note
    }
  }
`;